
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Markdown from 'react-markdown';
import Header from "../../components/common/Header";
import useTranslation from "next-translate/useTranslation";
import BlogLayout from "../../layouts/blog";
import { formattedDate } from "../../helpers/dateFormater";
import React, { useEffect, useState } from "react";
import Footer from "../../components/common/Footer";
import Loader from "../../components/common/Loader";
import BackButton from "../../components/common/BackButton";
export default function Post({ post }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (post) {
            setIsLoading(false);
            setLoaded(true);
        }
        return () => {
            setIsLoading(true);
            setLoaded(false);
        };
    }, [post]);
    console.log(post);
    return (<BlogLayout title={post?.title + " | Coldware"} description={post?.description} keywords={''} page={'post'} canonical={post?.slug}>
            <Header t={t}/>
            <section className={'banner'}>
                <div className="container">
                    <BackButton />
                    <div className="banner_wrapper">
                        <p className={'banner_wrapper_date'}>{formattedDate(post?.updatedAt)}</p>
                        {/*<h2 className={'banner_wrapper_title'}>{post?.title}</h2>*/}
                        <img className={'banner_wrapper_cover'} src={`${process.env.NEXT_PUBLIC_BLOG_API_URL}${post?.cover?.url?.slice(1)}`} alt={''}/>
                    </div>
                </div>
            </section>
            <section className={'post_body'}>
                <div className="container">
                    <Markdown>{post?.content}</Markdown>
                </div>
            </section>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </BlogLayout>);
}
// export async function getStaticPaths(router) {
//     try {
//         const res = await fetch(`${process.env.NEXT_PUBLIC_BLOG_API_URL}api/blogs`);
//         const posts = await res.json();
//
//         const locales = router.locales;
//
//         const paths = posts.data.flatMap((post) =>
//             locales.map((locale) => ({
//                 params: { slug: post.slug },
//                 locale,
//             }))
//         );
//
//         return {paths, fallback: 'blocking'};
//     } catch (error) {
//         console.error("Error fetching paths:", error);
//         return {paths: [], fallback: false};
//     }
// }
async function getServerSideProps({ params }) {
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_BLOG_API_URL}api/blogs?filters[slug]=${params.slug}&populate=*`);
        const postData = await res.json();
        const post = postData.data[0];
        return {
            props: { post }
        };
    }
    catch (error) {
        console.error("Error fetching post:", error);
        return { notFound: true };
    }
}

    async function __Next_Translate__getServerSideProps__197269f9943__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__197269f9943__ as getServerSideProps }
  